package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "nl")
val NlStrings = Strings(
    analyzer = "Analysator",
    appreciationOverview = "Waarderingsoverzicht",
    chartLegendInterest = "Rente",
    chartLegendPrincipal = "Hoofdsom",
    chartXaxisMonths = "Maanden",
    chartYaxisPayment = "Betaling",
    code = "nl",
    costOfCredit = "Kosten van Krediet",
    creditDealAnalyzerDescription = "Voer uw leninggegevens in om een uitgebreide analyse van uw kredietdeal te ontvangen. Onze analysator evalueert belangrijke statistieken om u te helpen de werkelijke kosten van uw lening te begrijpen và een weloverwogen beslissing te nemen.",
    detailsGoodRateLongTerm = "Goed tarief maar lange termijn resulteert in hoge totale kosten.",
    detailsHighApr = "Hoog JKP. ",
    detailsHighInterestCost = "Hoge totale rentekosten.",
    detailsHighRateShortTerm = "Hoog tarief maar korte termijn houdt de totale kosten laag.",
    detailsLowApr = "Laag JKP. ",
    detailsLowInterestCost = "Lage totale rentekosten.",
    discountsTradeIn = "Kortingen / Inruil",
    displayName = "Nederlands",
    distribution = "Verdeling",
    downPayment = "Aanbetaling",
    effectiveApr = "JKP",
    headerBalance = "Saldo",
    headerDate = "Datum",
    headerInterest = "Rente",
    headerMonth = "#",
    headerPayment = "Betaling",
    headerPrincipal = "Hoofdsom",
    hideDetails = "Details verbergen",
    interest = "Rente",
    invalidData = "Ongeldige gegevens",
    loanAmountSupportingText = "Het totale leenbedrag, inclusief eventuele extra kosten.",
    loanDetails = "Leningdetails",
    paymentSupportingText = "Uw geschatte maandelijkse betaling.",
    paymentComposition = "Betalingssamenstelling",
    percentSymbol = "%",
    principal = "Hoofdsom",
    ratingBad = "Slechte Deal",
    ratingExcellent = "Uitstekende Deal",
    ratingFair = "Eerlijke Deal",
    ratingGood = "Goede Deal",
    ratingPoor = "Matige Deal",
    schedule = "Schema",
    showDetails = "Details tonen",
    summaryBad = "Zeer ongunstig, vermijd indien mogelijk.",
    summaryExcellent = "Uitstekende financiële voorwaarden.",
    summaryFair = "Eerlijke voorwaarden, overweeg te onderhandelen.",
    summaryGood = "Goede voorwaarden, standaard voor de markt.",
    summaryPoor = "Slechte voorwaarden, hoge kosten of tarief.",
    totalPaid = "Totaal Betaald",
    lockTaxRate = "Belastingtarief vergrendelen",
    unlockTaxRate = "Belastingtarief ontgrendelen",
    currencySymbol = "€",
    currency = "Valuta",
    totalCreditAmount = "Totaal Kredietbedrag",
    taxAmount = "Belasting/Aftrekbedrag",
    netAmountDisbursed = "Netto Uitbetaald Bedrag",
    years = "Jaren",
    loanTermTotalMonths = "Looptijd Lening (Maanden)",
    monthlyInstallment = "Maandelijkse Termijn",
    principalInstallment = "Aflossing Hoofdsom",
    otherFees = "Andere Kosten",
    insuranceCost = "Verzekeringspremie",
    aprc = "Jaarlijks Kostenpercentage (JKP)",
    totalAmountPayable = "Totaal te betalen bedrag",
    prepaidFeeFixed = "Verwerkingskosten (Vast Bedrag)",
    prepaidFeePercentage = "Verwerkingskosten (Percentage)",
    months = "Maanden",
    description = "Deze analysator helpt u te evalueren of een leningaanbieding gunstig voor u is. In tegenstelling tot standaard rekenmachines is er geen invoer van rentepercentage vereist. In plaats daarvan berekent het het JKP và de totale kosten van het krediet op basis van betalingen và kosten, và biedt het een dealbeoordeling và gedetailleerde grafieken.",
    agree = "Akkoord",
    information = "Informatie",
    errorCalculationOverflow = "JKP is te hoog, rekenkundige overloop.",
    errorTotalPaymentIsLessThanLoanAmount = "Het ontvangen bedrag is lager dan het geleende bedrag.",
    errorDivisionByZero = "Deling door nul",
    errorNegativeResult = "Negatief resultaat",
    errorRateTooHigh = "Tarief is te hoog",
    errorCalculation = "Voer de juiste gegevens in",
    close = "Sluiten",

    hi = "Hoi",
    guest = "Gast",
    account = "Account",
    signInWithGoogle = "Inloggen met Google",
    signOut = "Uitloggen",
    settings = "Instellingen",
    about = "Over",
    privacyPolicy = "Privacybeleid",
    termsOfService = "Servicevoorwaarden",
    language = "Taal",

    theme = "Thema",
    light = "Licht",
    dark = "Donker",
    system = "Systeem",
    toggleExpand = "Uitvouwen/Samenvouwen",
)
